import PropTypes from 'prop-types';
import './StatusBadge.css';

// 상태 값을 색 배지로 보여준다. done이면 완료 색을 쓴다.
export default function StatusBadge({ label, done }) {
    return <span className={`admin-status-badge${done ? ' done' : ''}`}>{label}</span>;
}

StatusBadge.propTypes = {
    label: PropTypes.string.isRequired,
    done: PropTypes.bool,
};
